module.exports = __webpack_public_path__ + "img/CreateProfile.fd20035b.svg";